import * as React from 'react';
const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return Object.assign(Object.assign({}, state), { [action.contentPath]: action.value });
        case 'bulk-update':
            return Object.assign(Object.assign({}, state), action.changeset);
    }
};
const Context = React.createContext(undefined);
export function useContentContainerState(initialState) {
    const context = React.useContext(Context);
    const [localState, localDispatch] = React.useReducer(reducer, (context === null || context === void 0 ? void 0 : context.state) || initialState || {});
    const dispatch = (context === null || context === void 0 ? void 0 : context.dispatch) || localDispatch;
    const update = React.useCallback((contentPath, value) => dispatch({
        type: 'update',
        contentPath,
        value,
    }), [dispatch]);
    const batchUpdate = React.useCallback((changeset) => dispatch({
        type: 'bulk-update',
        changeset,
    }), [dispatch]);
    return {
        state: (context === null || context === void 0 ? void 0 : context.state) || localState,
        update,
        batchUpdate,
        dispatch,
    };
}
export const SpawnContext = ({ data, children, }) => {
    const { state, dispatch } = useContentContainerState(data);
    return (React.createElement(Context.Provider, { value: { state, dispatch } }, children));
};
//# sourceMappingURL=context.js.map